import { IconSearch16 } from '@warp-ds/icons/react/search-16';
import { Button } from '@warp-ds/react/components/button';
import { Modal } from '@warp-ds/react/components/modal';
import type { ReactElement } from 'react';
import { useBreakpoints } from '../../hooks/useBreakpoints';

type SearchPanelProps = {
    showSearchForm: boolean;
    setShowSearchForm: (value: boolean) => void;
    searchForm: ReactElement;
    searchDetails: ReactElement;
};

export const SearchPanel = ({ showSearchForm, setShowSearchForm, searchForm, searchDetails }: SearchPanelProps) => {
    const isMobile = useBreakpoints({ breakpoint: 'md' });

    return (
        <>
            <div className={`flex items-center gap-8 md:gap-16 md:p-16 ${showSearchForm ? 'md:hidden' : ''}`}>
                <IconSearch16 className="md:hidden" aria-hidden />
                <div className="grow">{searchDetails}</div>
                <Button
                    link
                    aria-label="Endre søk"
                    onClick={() => setShowSearchForm(true)}
                    className="font-bold text-s md:text-m whitespace-nowrap"
                    data-testid="editSearchButton">
                    Endre søk
                </Button>
            </div>
            {!isMobile && showSearchForm && <div className="hidden md:block p-16 md:p-32">{searchForm}</div>}
            <Modal
                title="Endre søk"
                open={isMobile && showSearchForm}
                right
                onDismiss={() => setShowSearchForm(false)}
                className="md:hidden">
                {searchForm}
            </Modal>
        </>
    );
};
